(() => {
  const testId = "DLT-011";

  // --- Only run on mobile + home page ---
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const isHome =
    location.pathname === '/' ||
    document.body.classList.contains('template-index') ||
    document.body.classList.contains('index');

  if (!isMobile || !isHome) return;

  const categoryButtons = [
    { label: "Shop All",    href: "https://donkeylongtong.co.za/collections/all" },
    { label: "Combo Deal",  href: "https://donkeylongtong.co.za/products/combo" },
    { label: "Personalise", href: "https://donkeylongtong.co.za/pages/custom-name-heat-press" },
    { label: "Jack Sack",   href: "https://donkeylongtong.co.za/products/the-jack-sack" },
    { label: "Bestseller",  href: "https://donkeylongtong.co.za/products/braai-tong-donkey-long-tong" },
  ];

  const html = `
    <div class="${testId}-category-buttons-container">
      ${categoryButtons.map(b => `<a href="${b.href}" class="${testId}-category-button">${b.label}</a>`).join("")}
    </div>
  `;

  const wrapper = document.querySelector('div.header__wrapper');
  if (!wrapper) return;

  // Insert ONLY in the main header (non-sticky)
  const mainHeader = wrapper.querySelector('header.theme__header');
  const mobileRow = mainHeader?.querySelector('.header__mobile');

  if (mainHeader && !mainHeader.querySelector(`.${testId}-category-buttons-container`)) {
    if (mobileRow) mobileRow.insertAdjacentHTML('afterend', html);
    else mainHeader.insertAdjacentHTML('beforeend', html);
  }

  // Clean up any that exist in sticky header (scroll-up header)
  document.querySelectorAll(`div.header__wrapper.js__header__stuck header.theme__header .${testId}-category-buttons-container`)
    .forEach(el => el.remove());

  // Extra safety: if sticky class toggles on scroll, hide bar while sticky
  const buttons = mainHeader.querySelector(`.${testId}-category-buttons-container`);
  const observer = new MutationObserver(() => {
    const stuck = wrapper.classList.contains('js__header__stuck');
    if (buttons) buttons.style.display = stuck ? 'none' : 'flex';
  });
  observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
})();